import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import SubPaywall from '../../../DeviationViews/Full/_partials/SubPaywall';
import StatBlock from '../../Details/_partials/StatBlock';
import TextContent from '../../Details/_partials/TextContent';

import s from './Journal.scss';

export interface Props {
  deviation: PapiDeviation;
  withArtist?: boolean;
}

const JournalContent: React.FC<Props> = ({
  deviation: { textContent },
  deviation,
  withArtist = true,
}) => {
  const isLegacy = textContent?.html.type === 'writer';
  const isLegacyView = isLegacy && !deviation.extended?.journalSkinFullwidth;
  const isFullWidthView = isLegacy && deviation.extended?.journalSkinFullwidth;
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);

  const isMobile = useContext(MobileContext);
  const { isSubscribedButBlocked, needsSubscription } = useSubscriptionTier(deviation);
  const isBlocked = needsSubscription || isSubscribedButBlocked;

  // only show here in full screen, otherwise it's shown in DesktopLayout in the left column
  const { isFullscreen } = useDeviationViewContext();
  const shouldShowFullscreenSubPaywall = isBlocked && isFullscreen;

  return (
    <>
      {withArtist && (
        <div className={s['author-block']}>
          <SubmissionDetails deviation={deviation} />
          {/* include whitespace to force a non-zero height */}
          {!isMobile && ' '}
        </div>
      )}
      <StatBlock className={s['stats']} deviation={deviation} />

      {!isBlocked && (
        <div className={s['wrapper']}>
          {isExtendedLoaded && (
            <TextContent
              className={classnames(
                s['text-content'],
                isLegacyView && s['is-legacy-journal'],
                isFullWidthView && s['is-fullwidth-skin']
              )}
              textContent={textContent}
              deviationId={deviation.deviationId}
              disableStylesForLegacy={isFullWidthView}
            />
          )}
        </div>
      )}

      {shouldShowFullscreenSubPaywall && (
        <SubPaywall className={s['paywall']} deviation={deviation} showImage={false} />
      )}
    </>
  );
};
JournalContent.displayName = 'JournalContent';

export default JournalContent;
